@if (workForm) {
  <form autocomplete="off" novalidate>
    <app-slide-over [backdropBlur]="true">
      <app-slide-over-header
        (closeSlideOver)="closeSlideOver()"
        [title]="title"
        [formDirty]="workForm.dirty"
        #headerComponent
      >
      </app-slide-over-header>
      @if (data?.work?.data?.invoice) {
        <app-slide-over-alert
          heading="Diese Stunden wurden bereits verrechnet"
          subheading="Um was zu ändern muss die Rechnung storniert werden."
        ></app-slide-over-alert>
      }
      <app-slide-over-content>
        @if (showSuggestions) {
          @if (suggestions | async; as suggestions) {
            @if (suggestions.length > 0) {
              <div class="px-4 sm:px-6 pt-4">
                <app-work-suggestions
                  [suggestions]="suggestions"
                  (selectSuggestion)="selectSuggestion($event)"
                ></app-work-suggestions>
              </div>
            }
          }
        }
        <div class="space-y-6 divide-y divide-separator">
          <div class="space-y-4 pt-6 pb-6 px-4 sm:px-6">
            <app-dropdown
              label="Mitarbeiter"
              [formControl]="workForm.controls.orgaUser"
              [options]="orgaUsers"
            ></app-dropdown>
            <app-dropdown
              label="Projekt"
              [formControl]="workForm.controls.project"
              [options]="projectSummaries"
            ></app-dropdown>
            <app-dropdown
              label="Position"
              [formControl]="workForm.controls.position"
              [options]="positionSummaries"
            ></app-dropdown>
          </div>
          <div class="space-y-4 pt-6 pb-5 px-4 sm:px-6">
            <app-date-input label="Datum" [formControl]="workForm.controls.date"></app-date-input>
            <app-text-input
              label="Beschreibung"
              [formControl]="workForm.controls.description"
              variant="textarea"
            ></app-text-input>
            @if (isSessionMode) {
              <div class="grid grid-cols-2 gap-4">
                <app-form-input-wrapper label="Start" [control]="sessionStartTime">
                  <input
                    #startInput
                    appTailwindInput2
                    [control]="sessionStartTime"
                    [disabled]="sessionTimeControlsDisabled"
                    [value]="sessionStartTime.value"
                    (input)="updateSessionStartTime(startInput.value)"
                    type="time"
                    step="60"
                  />
                </app-form-input-wrapper>
                <app-form-input-wrapper label="Ende" [control]="sessionEndTime">
                  <input
                    #endInput
                    appTailwindInput2
                    [control]="sessionEndTime"
                    [disabled]="sessionTimeControlsDisabled"
                    [value]="sessionEndTime.value"
                    (input)="updateSessionEndTime(endInput.value)"
                    type="time"
                    step="60"
                  />
                </app-form-input-wrapper>
              </div>
              <div>
                <span class="block text-sm font-medium leading-6 text-fg-primary">Dauer</span>
                <output
                  class="mt-2 block w-full rounded-md bg-surface-input px-3 py-1.5 text-sm leading-6 text-fg-primary"
                  aria-live="polite"
                >
                  {{ sessionDuration }}
                </output>
              </div>
              @if (timeEntryError) {
                <p class="text-sm text-red-600" role="alert">{{ timeEntryError }}</p>
              }
            } @else {
              <app-work-time-input
                label="Arbeitszeit"
                [formControl]="workForm.controls.workMinutes"
              ></app-work-time-input>
            }
          </div>
        </div>
      </app-slide-over-content>
      <app-slide-over-footer>
        @if (!data?.work?.data?.invoice) {
          <app-dropdown-minimal-menu>
            <app-dropdown-button
              ><app-ng-icon class="text-xl" name="heroTrash"></app-ng-icon
            ></app-dropdown-button>
            <app-dropdown-item (menuClick)="deleteWork()"> Löschen </app-dropdown-item>
          </app-dropdown-minimal-menu>
        }
        <span class="inline-flex rounded-md shadow-sm">
          <button
            appTailwindButton
            color="secondary"
            type="button"
            (click)="headerComponent.closeSlideOverClicked()"
          >
            Abbrechen
          </button>
        </span>
        <span class="inline-flex rounded-md shadow-sm">
          <button
            appTailwindButton
            [disabled]="data?.work?.data?.invoice || saving || (isSessionMode && !isSessionSourceSameDay)"
            type="button"
            (click)="saveWork()"
            class="grid grid-cols-1"
          >
            <span class="col-start-1 row-start-1">Speichern</span>
            @if (saving) {
              <svg
                class="col-start-1 row-start-1 animate-spin -ml-1 h-5 w-5 text-white justify-self-center"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                ></circle>
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
            }
          </button>
        </span>
      </app-slide-over-footer>
    </app-slide-over>
  </form>
}
